module.exports = __webpack_public_path__ + "static/preview-faro-2f90bbfe47ce7b0fe497fa1f425f4502.jpg";